/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Overview_Downgrade_To_StarterInputs */



/**
* | output |
* | --- |
* | "Downgrade to Starter" |
*
* @param {Sub_Overview_Downgrade_To_StarterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_downgrade_to_starter = /** @type {((inputs?: Sub_Overview_Downgrade_To_StarterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Downgrade_To_StarterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Downgrade auf Starter")
	return /** @type {LocalizedString} */ ("Downgrade to Starter")
});